import React from 'react';
import {useHistory} from 'react-router'
import {makeStyles, Container, Grid, Typography, Dialog, Paper} from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import {MuiThemeProvider, responsiveFontSizes} from '@material-ui/core/styles';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import Edit from './Edit'
import EmployeeAllowanceCollection from '../../Function/EmployeeAllowanceCollection'
import CircularProgress from '@material-ui/core/CircularProgress';
import customAxios from "../../../components/API/customAxios";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import {tableStyle, getMuiTheme, tableTheme} from "../../UIComponent/CommonStyle"
import Export from "./Export";
import LoadingOverlay from 'react-loading-overlay';
import {decimal} from "../../Function/globalFunction";

const useStyles = makeStyles((theme) => ({
    ...tableStyle(theme),
}));
const thisTheme = responsiveFontSizes(tableTheme);

export default function EmployeeRecord() {
    const classes = useStyles();
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [isActive, setIsActive] = React.useState(false);
    const history = useHistory();
    const [open, setOpen] = React.useState(false);
    const [submitCompletePopup, setCompletePopupOpen] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [showId, setShowId] = React.useState();
    const [columns, setColumns] = React.useState([
        {
            name: "id",
            label: "ID",
            options: {
                filter: false,
                sort: true,
                display: false,
                download: false,
            }
        },
        {
            name: "staffNo",
            label: "Staff No.",
            options: {
                filter: true,
                sort: true,
                filterType: "textField",
            }
        },
        {
            name: "employee",
            label: "Employee",
            options: {
                filter: true,
                sort: true,
                filterType: "textField",
            }
        },
        {
            name: "position",
            label: "Position",
            options: {
                filter: true,
                sort: false,
                filterType: "textField",
            }
        },
        {
            name: "location",
            label: "Location",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "department",
            label: "Department",
            options: {
                filter: true,
                sort: false,
            }
        }
    ]);

    React.useEffect(() => {
        let isMounted = true;

        async function fetchData() {
            customAxios.get(`/get_employee_allowances`)
            .then(res => {
                const getAllAllowanceRecord = res.data['results'];
                const year = res.data['active_year'];
                setData(EmployeeAllowanceCollection(getAllAllowanceRecord, 'EmployeeRecord'));

                let addColumns = [];
                for (let i = 2; i >= 0; i--) {
                    addColumns.push({
                            name: 'total_' + year[i],
                            label: year[i] + ' AL Entitled',
                            options: {
                                filter: false,
                                sort: false,
                                customBodyRender: value => {
                                    return decimal(value, false);
                                }
                            }
                        },
                        {
                            name: 'taken_' + year[i],
                            label: year[i] + ' AL Taken',
                            options: {
                                filter: false,
                                sort: false,
                                customBodyRender: value => {
                                    return decimal(value, false);
                                }
                            }
                        })
                }
                addColumns.push(
                    {
                        name: "sickTotal",
                        label: "SL Entitled",
                        options: {
                            filter: false,
                            sort: false,
                            display: false,

                        }
                    },
                    {
                        name: "sickTaken",
                        label: "SL Taken",
                        options: {
                            filter: false,
                            sort: false,
                            display: false,
                        }
                    },
                    {
                        name: "active",
                        label: "Status",
                        options: {
                            filter: true,
                            filterList: ['Active'],
                            sort: false,
                            download: false,
                        }
                    },
                    {
                        name: "Edit",
                        options: {
                            filter: false,
                            sort: false,
                            download: false,
                            empty: true,
                            customBodyRender: (value, tableMeta, updateValue) => {
                                return (
                                    <BorderColorIcon onClick={() => handleOpen(tableMeta.rowData[0])}
                                                     className={classes.muiDataTableIcon}/>
                                );
                            }
                        }
                    }
                )
                const merge = columns.concat(addColumns);
                setColumns(merge)
                setShowCompetent(true);
            }, error => {
                if (error.response.status === 401) {
                    history.push('/home');
                }
            });
        }
        fetchData();

        return () => {
            isMounted = false;
        };
    }, []);

    const handleOpen = (id) => {
        setShowId(id)
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleCompletePopupClose = () => {
        setCompletePopupOpen(false);
    };

    const updateNewAllowanceRecord = (values) => {
        setCompletePopupOpen(true);
        const tempDatas = data;
        tempDatas.forEach((element) => {
            if (String(element.id) === String(values.id)) {
                const annualAllowances = values.annual_allowances;
                {
                    annualAllowances.map(function (annualAllowance, i) {
                        if (element.hasOwnProperty('total_' + annualAllowance.year)) {
                            element['total_' + annualAllowance.year] = annualAllowance.total;
                        }

                        if (element.hasOwnProperty('taken_' + annualAllowance.year)) {
                            element['taken_' + annualAllowance.year] = annualAllowance.taken;
                        }
                    })
                }

                const sickAllowances = values.sick_allowances;

                element.sickTotal = sickAllowances.total;
                element.sickTaken = sickAllowances.taken;
            }
        })
        setData(tempDatas);
    };

    const options = {
        filterType: 'checkbox',
        selectableRows: 'none',
        elevation: 1,
        print: false,
        search: false,
        download: false,
        textLabels: {
            body: {
                noMatch: 'No matching records found',
            },
        },
        customToolbar: () => {
            return (
                <Export setIsActive={setIsActive}/>
            );
        },
    };

    return (
        <MuiThemeProvider theme={thisTheme}>
            <main className={classes.content}>
                <div className={classes.appBarSpacer}/>
                <Container maxWidth={false} className={classes.container}>
                    {showCompetent ?
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Typography component="h1" variant="h5" align="left" style={{fontWeight: 600}}>
                                    Employee Records
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <LoadingOverlay
                                    active={isActive}
                                    styles={{
                                        overlay: base => ({
                                            ...base,
                                            background: '#D0D0D0',
                                            opacity: 0.7,
                                        }),
                                    }}
                                    spinner
                                >
                                    <MuiThemeProvider theme={getMuiTheme()}>
                                        <MUIDataTable
                                            title={"Employee List"}
                                            data={data}
                                            columns={columns}
                                            options={options}
                                        />
                                    </MuiThemeProvider>
                                </LoadingOverlay>
                            </Grid>
                        </Grid>
                        :
                        <div className={classes.circularProgress}>
                            <CircularProgress/>
                        </div>
                    }
                </Container>
                {open && (
                    <Edit handleClose={handleClose} open={open} showId={showId}
                          updateNewAllowanceRecord={updateNewAllowanceRecord} backToTable={handleClose}/>
                )}
                <Dialog
                    open={submitCompletePopup}
                    onClose={handleCompletePopupClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <Paper className={classes.afterSubmitPage}>
                        <IconButton aria-label="close" className={classes.closeButton}
                                    onClick={handleCompletePopupClose}>
                            <CloseIcon/>
                        </IconButton>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography style={{fontSize: '20px'}}>Edit Successful</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <CheckCircleIcon style={{fontSize: '100px', color: 'green'}}/>
                            </Grid>
                        </Grid>
                    </Paper>
                </Dialog>
            </main>
        </MuiThemeProvider>
    );
}
